import { BASE_URL } from 'configs';
import request from 'utils/axios';
import { AuditLogEntry } from './types';

export const AUDIT_LOG_URL = `${BASE_URL}/api/audit-log`;

/** Admin-only. `sort` is the only server-side option the backend exposes (asc | desc, default desc). */
export const getAuditLogs = (sort: 'asc' | 'desc' = 'desc'): Promise<AuditLogEntry[]> =>
  request(AUDIT_LOG_URL, { method: 'GET', includeAuth: true, params: { sort } });
